import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";


import BedAllocation from "../../HospitalPages/IPD/Bed Aoolcation/BedAllocation";
import ClinicalNotes from "../../HospitalPages/IPD/Clinical Notes/ClinicalNotes";
import IPDBilling from "../../HospitalPages/IPD/IPD Billing/IPDBilling";
import IPDReports from "../../HospitalPages/IPD/IPD Reports/IPDReports";
import NewAdmission from "../../HospitalPages/IPD/NewAdmission";
import WardTransferBedShift from "../../HospitalPages/IPD/WardTransferBedShift";
import DischargeSummaryGeneration from "../../HospitalPages/IPD/DischargeSummaryGeneration";
import { decrypt } from "../../components/cryptoUtil";
import DashboardCards from "../HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "../componenet/heading";


const IpdDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const tokenData = localStorage.getItem("tokenData");
  const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  const userName = decryptedData.userfullname || "";
  const userRole = decryptedData.userrole || "";


  const cardRoles = {
    "IPD Patient Registration": [ROLES.RECEPTIONIST], // only userRole 101 can see
    "Bed Allocation": [ROLES.RECEPTIONIST],   // only userRole 102 can see
    "Ward Transfer / Bed Shift": [ROLES.RECEPTIONIST],
    "Clinical Notes / Prescriptions": [ROLES.STAFF],
    "Discharge Summary Generation": [ROLES.ACCOUNTSECTION],
    "IPD Billing": [ROLES.DOCTOR, ROLES.RECEPTIONIST],
    "IPD Reports": [ROLES.ACCOUNTSECTION],

  };


  const cards = [
    ...includeCardForRoles(cardRoles["IPD Patient Registration"], userRole, {
      title: "IPD Patient Registration",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <NewAdmission />, category: "👨‍⚕️ IPD Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Bed Allocation"], userRole, {
      title: "Bed Allocation",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <BedAllocation />, category: "👨‍⚕️ IPD Data Managament",
    }),

    ...includeCardForRoles(cardRoles["Ward Transfer / Bed Shift"], userRole, {
      title: "Ward Transfer / Bed Shift",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <WardTransferBedShift />, category: "👨‍⚕️ IPD Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Clinical Notes / Prescriptions"], userRole, {
      title: "Clinical Notes / Prescriptions",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <ClinicalNotes />, category: "👨‍⚕️ IPD Data Managament",
    }),

    ...includeCardForRoles(cardRoles["Discharge Summary Generation"], userRole, {
      title: "Discharge Summary Generation",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <DischargeSummaryGeneration />, category: "👨‍⚕️ IPD Data Managament",
    }),

    ...includeCardForRoles(cardRoles["IPD Billing"], userRole, {
      title: "IPD Billing",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <IPDBilling />, category: "👨‍⚕️ IPD Data Managament",
    }),
    ...includeCardForRoles(cardRoles["IPD Reports"], userRole, {
      title: "IPD Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <IPDReports />, category: "👨‍⚕️ IPD Data Managament",
    }),
  ];


  return (
    <DashboardCards
      cards={cards}
      menulabel={1}
      welcomeMessage={
        <Typography variant="h5" align="center" gutterBottom>
          👨‍⚕️ IPD Data Managament
        </Typography>
      }
    />
  );
};

export default IpdDashBoard;
